import useTranslation from 'next-translate/useTranslation'
import React, { useMemo } from 'react'

import GHref from 'tennders-market/common/components/element/GHref'
import MultipleSalesInvoiceDiscountRow
  from 'tennders-finance/sales-invoice/components/multiple-sales-invoice/MultipleSalesInvoiceDiscountRow'

const MultipleSalesInvoiceDiscountsTable = (props) => {
  const {
    discountLines,
    lines,
    editMode,
    discountErrors,
    onDiscountFormChange,
    removeDiscountLine,
    onNewAddDiscountLine,
    totalAmountOnInvoice,
    totalExtraCosts,
    defaultVat, companyId,
    selectedPaymentTerm,
    isCreditNote
  } = props
  const { t } = useTranslation('multiple_cost_invoice')

  const renderDiscountLines = useMemo(() => {
    const dLines = discountLines.map((discount: Record<string, any>, index) => {
      const costPrice = discount.applyTo === 'all' ? totalExtraCosts + totalAmountOnInvoice : totalAmountOnInvoice
      return (
        <MultipleSalesInvoiceDiscountRow
          initialErrors={discountErrors}
          key={discount.id}
          discountLinesLength={discountLines.length}
          editMode={editMode}
          selectedPaymentTerm={selectedPaymentTerm}
          keyIndex={discount.id}
          isCreditNote={isCreditNote}
          index={index}
          companyId={companyId}
          defaultVat={defaultVat}
          onFormChange={onDiscountFormChange}
          costPrice={costPrice}
          removeLine={removeDiscountLine}
        />
      )
    })
    return dLines
  }, [totalAmountOnInvoice, totalExtraCosts, discountLines, discountErrors, selectedPaymentTerm])

  const addButtonText = useMemo(() => (discountLines?.length > 0 ? t('add_discount') : t('add_another_discount')), [discountLines])

  return (
    <>
      <div className="hr"></div>
      <p className="text-uppercase mb-10 ls-1">
        <strong>Discounts</strong>
      </p>
      <table
        className="tennders-table-zebra "
        style={{ minWidth: 900 }}
      >
        <thead>
          <tr>
            <th />
            <th>#</th>
            <th colSpan={2}>Apply type</th>
            <th>Concept</th>
            <th>Percentage</th>
            <th>Amount</th>
            <th>Vat Percentage</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {renderDiscountLines}
        </tbody>
      </table>
      {/*! isCreditNote && (
        <GHref className="btn-border small color-p mt-16" onClick={() => onNewAddDiscountLine()}>
          <span className=" mr-6">
            <i
              className="fa fa-plus"
              aria-hidden="true"
            />
          </span>
          {addButtonText}
        </GHref>
      ) */}
      <div className="hr"></div>
    </>
  )
}

export default React.memo(MultipleSalesInvoiceDiscountsTable)
